module.exports = __webpack_public_path__ + "static/img/ImgConversation@2x.84ffa5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ImgConversation@2x.png
// module id = ro+n
// module chunks = 0